export enum CommissionStatusCodes {
  STATUS_DELETED = -2,
  STATUS_CREATED = -1,
  STATUS_ACTIVE = 1,
}

export enum CommissionStatusType {
  ACTIVE = 'active',
  DISABLED = 'disabled',
}

export const CommissionStatusCodeMap = {
  [CommissionStatusType.ACTIVE]: CommissionStatusCodes.STATUS_ACTIVE,
  [CommissionStatusType.DISABLED]: CommissionStatusCodes.STATUS_CREATED,
};

export const CommissionStatusMap = {
  [CommissionStatusCodes.STATUS_ACTIVE]: CommissionStatusType.ACTIVE,
  [CommissionStatusCodes.STATUS_CREATED]: CommissionStatusType.DISABLED,
};
